import { useDispatch, useSelector } from 'react-redux';

import useMoveToWorkspaceAction from '../../../../hooks/useMoveToWorkspaceAction';
import { userSelectors } from '../../../../store/modules/user';
import { videoFolderActions } from '../../../../store/modules/videoFolder';

type UseMoveProjectToWorkspaceActionProps = {
  projectId: string;
};

const useMoveProjectToWorkspaceAction = ({ projectId }: UseMoveProjectToWorkspaceActionProps) => {
  const dispatch = useDispatch();

  const profile = useSelector(userSelectors.selectUserProfile);

  return useMoveToWorkspaceAction({
    onMoveToTeam: () => dispatch(videoFolderActions.moveProjectToTeam({ projectId })),
    onMoveToUser: () => profile && dispatch(videoFolderActions.moveProjectToUser({ projectId, userId: profile.userId }))
  });
};

export default useMoveProjectToWorkspaceAction;
